import { Document, pdf } from "@react-pdf/renderer";
import { Storage, API, Auth } from "aws-amplify";
import { PdfBuro } from "components/Loan/LoanMain";
import { PdfBuroLetter } from "components/PdfViewer/PdfViewerMain";
import React, { useState } from "react";
import { getDetailSegment } from "../../../utils/buro";
import { Button } from "./wrapper";
import { differenceInDays, format } from "date-fns";
import PDFMerger from "pdf-merger-js/browser";
import { getCountLetter } from "./letterBuro";
import { pad } from "utils/getLocalDateTime";
import { PdfInstallment } from "components/Loan/LoanMain";
import _ from "lodash";
import { calReportAging } from "utils/calReportAging";
import { getFilterLoanBuro } from "components/BuroBug/BuroMainTwo";

const Minizip = require("minizip-asm.js");

function SendEmail({
  loan = [],
  buroDate = new Date(),
  interest,
  loanLastPaymentDone = [],
}) {
  const [loanEmail, setLoanEmail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorEmail, setErrorEmail] = useState(null);

  const nextTimeOut = (duration = 1000) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, duration);
    });
  };

  const onClickSendEmail = async () => {
    try {
      setLoading(true);
      let index = 0;

      console.log("loan", loan);

      let { dataPrinciple: newLoan } = calReportAging(loan, buroDate);

      newLoan = _.cloneDeep(newLoan).filter((itemLoan) => {
        return itemLoan.loan_id;
      });

      let filterLoan = _.cloneDeep(newLoan).filter((itemLoan) => {
        const diffDefaultDate = differenceInDays(
          new Date(buroDate),
          new Date(itemLoan.overdue_date)
        );
        return diffDefaultDate <= 1915; //มากกว่า 5ปี 90วัน
      });

      filterLoan = getFilterLoanBuro(filterLoan, buroDate, interest);

      filterLoan = [...filterLoan, ...loanLastPaymentDone];

      console.log("filterLoan", filterLoan.length);

      for (const itemLoan of filterLoan) {
        console.log("index", index);
        await postSendEmail(itemLoan, filterLoan, index);
        await nextTimeOut(1000);
        index++;
      }

      setLoanEmail(filterLoan.length);
    } catch (error) {
      console.log("send email error", error);
      setErrorEmail(error);
    } finally {
      setLoading(false);
    }
  };

  const postSendEmail = async (itemLoan, filterLoan, index, duration = 1) => {
    try {
      const merger = new PDFMerger();
      if (itemLoan.email) {
        const dataBuro = getDetailSegment({
          currentDate: new Date(buroDate),
          dataExport: [itemLoan],
          showLog: true,
          showConsole: false,
          addressComma: true,
          logType: "KEY",
        });
        const letter_id = await getCountLetter(filterLoan);
        let urlBlob = "";
        try {
          urlBlob = await Storage.get(
            `${itemLoan.request_id}_contract_final.pdf`,
            {
              download: true,
            }
          );
        } catch (error) {
          if (itemLoan.contractUri) {
            urlBlob = await Storage.get(`${itemLoan.contractUri}`, {
              download: true,
            });
          } else {
            urlBlob = await Storage.get(`${itemLoan.request_id}_contract.pdf`, {
              download: true,
            });
          }
        }
        let fileNameCondtion = "ขั้นตอนการแก้ไข กรณีเปิดไฟล์สัญญาสินเชื่อ.pdf";
        let urlCondition = await Storage.get(`${fileNameCondtion}`, {
          download: true,
        });
        let fileCondtion = new File([urlCondition.Body], `${urlCondition}`, {
          type: "pdf",
        });
        let fileContract = new File(
          [urlBlob.Body],
          `${itemLoan.request_id}_contract_final.pdf`,
          {
            type: "pdf",
          }
        );
        let blobBuro = await pdf(
          <Document>
            <PdfBuro data={itemLoan} letter_id={letter_id} index={index} />
          </Document>
        ).toBlob();
        let blobBuroLetter = await pdf(
          <PdfBuroLetter dataPdf={dataBuro} oriLoan={itemLoan} />
        ).toBlob();
        let blobDetail = await Storage.get(`รหัสและสถานะบัญชี.pdf`, {
          download: true,
        });
        let fileDetail = new File([blobDetail.Body], `รหัสและสถานะบัญชี.pdf`, {
          type: "pdf",
        });
        let blobInstallment = await pdf(
          <Document>
            <PdfInstallment data={itemLoan} />
          </Document>
        ).toBlob();
        // await merger.add(fileContract);
        // await merger.add(blobInstallment);
        await merger.add(blobBuro);
        await merger.add(blobBuroLetter);
        await merger.add(fileDetail);
        // await merger.add(fileCondtion);
        const blobMerger = await merger.saveAsBuffer();
        const mz = new Minizip();
        const splitBirthDay = itemLoan.birthdateTh.split("/");
        let password = "";
        if (splitBirthDay?.length === 3) {
          const fulldate = `${splitBirthDay[2]}-${pad(splitBirthDay[1])}-${pad(
            splitBirthDay[0]
          )}`;
          password = format(new Date(fulldate), "ddMMyyyy");
        }
        const fileNameSuffix = `${format(new Date(), "dd-MM-yyyy")}`;
        let filename = `LOAN_${itemLoan.loan_kbank_id}_${fileNameSuffix}`;
        const filenameZip = `LOAN_${itemLoan?.loan_kbank_id}_${fileNameSuffix}.zip`;
        mz.append(filename, blobMerger, { password });
        const fileMerger = new File([mz.zip()], filenameZip, {
          type: "application/x-zip-compressed",
        });
        await Storage.put(filenameZip, fileMerger);
        const url = await Storage.get(filenameZip);
        await API.post("MoneyHubAdmin", `/loan/sendEmail`, {
          body: {
            subject: `ส่ง บริษัท ข้อมูลเครดิตแห่งชาติ จำกัด สำหรับสัญญาสินเชื่อมันนี่ฮับเลขที่ ${itemLoan.loan_kbank_id}`,
            filename: filenameZip,
            path: url,
            email: itemLoan.email,
            loan_id: itemLoan.loan_id,
            request_id: itemLoan.request_id,
            reference_id: itemLoan.loan_kbank_id,
            birthdateTh: itemLoan.birthdateTh,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
      }
    } catch (error) {
      console.log("POST SEND EMAIL", error);
    }
  };

  return (
    <Button
      onClick={onClickSendEmail}
      loading={loading}
      disabled={loading || !loan.length}
      color="red"
    >
      {loanEmail > 0 && loanEmail} SendEmail
    </Button>
  );
}

export default SendEmail;
